import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import WhaleChart from "./WhaleChart";
import TradingViewWidget from "./TradingViewWidget";
import CoinPicker from "./CoinPicker";

const PAIR = (c) => (c === "USDT" || c === "USDC" ? "BTCUSDT" : `${c}USDT`);

export default function ChartPanel({ coin, market, onCoin, transfers, coins }) {
  const [interval, setInterval] = useState("1h");
  const [tab, setTab] = useState("whale");
  const cg = market && market.symbol === coin && market.source === "coingecko" ? market : null;
  const pair = cg ? `${coin}/USD` : PAIR(coin);
  const tvSymbol = cg ? `CRYPTO:${coin}USD` : `BINANCE:${pair}`;
  const pick = (sym, m) => onCoin(sym, m || null);
  const coinTransfers = transfers.filter((t) => t.symbol === coin);

  return (
    <section className="panel p-4" data-testid="chart-panel" id="chart-panel">
      <Tabs value={tab} onValueChange={setTab}>
        <div className="mb-3 flex flex-wrap items-center gap-3">
          <div className="flex flex-wrap gap-1" data-testid="header-coin-select">
            {coins.map((c) => (
              <button key={c} data-testid={`chart-coin-${c}`} onClick={() => pick(c)} className={`chip ${coin === c ? "active" : ""}`}>
                {c}
              </button>
            ))}
            <CoinPicker coin={coin} onCoin={pick} />
            {!coins.includes(coin) && <span className="chip active" data-testid="chart-coin-custom">{coin}</span>}
          </div>
          <div className="flex gap-1">
            {["15m", "1h", "4h", "1d"].map((i) => (
              <button key={i} data-testid={`chart-interval-${i}`} onClick={() => setInterval(i)} className={`chip ${interval === i ? "active" : ""}`}>
                {i}
              </button>
            ))}
          </div>
          <TabsList className="ml-auto bg-[#161D2A]">
            <TabsTrigger value="whale" data-testid="chart-tab-lightweight" className="font-mono text-xs">Whale markers</TabsTrigger>
            <TabsTrigger value="tv" data-testid="chart-tab-tradingview-official" className="font-mono text-xs">TradingView</TabsTrigger>
          </TabsList>
        </div>
        <div className="mb-2 flex flex-wrap items-center gap-4 font-mono text-[11px] text-slate-400">
          <span className="text-slate-200">{pair}</span>
          {(coin === "USDT" || coin === "USDC") && <span className="text-[#FFB300]">{coin} flows plotted on BTC chart</span>}
          {cg && <span className="text-slate-400" data-testid="cg-source-note">{cg.name} · not on Binance · chart from CoinGecko</span>}
          {!coins.includes(coin) && (
            <span className="text-[#FFB300]" data-testid="untracked-coin-note">Price chart only. Add its Ethereum contract under "Track a new coin" to get flow data</span>
          )}
          <span><span className="text-[#FF3D00]">▼</span> inflow to exchange</span>
          <span><span className="text-[#00E676]">▲</span> outflow from exchange</span>
          <span data-testid="chart-marker-count">{coinTransfers.filter((t) => t.direction === "inflow" || t.direction === "outflow").length} exchange flows</span>
        </div>
        <TabsContent value="whale" className="mt-0">
          <WhaleChart pair={pair} cgId={cg?.cg_id} interval={interval} transfers={coinTransfers} />
        </TabsContent>
        <TabsContent value="tv" className="mt-0">
          {tab === "tv" && <TradingViewWidget symbol={tvSymbol} interval={interval} />}
        </TabsContent>
      </Tabs>
    </section>
  );
}
